import { DoubleModal } from '@components'
import {
  SuggestionForm,
  SuggestionFormProps
} from '@pages/DocumentPage/DocumentDetails/AccountingSuggestions/SuggestionForm'
import { DocumentFormExtraDetailView } from '@pages/DocumentPage/DocumentForm/DocumentFormExtraDetailView'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

interface Props extends SuggestionFormProps {
  isVisible: boolean
  onFormValuesChange?: SuggestionFormProps['onValuesUpdate']
}

export const SuggestionFormModal: React.FC<Props> = ({
  suggestion,
  attachmentExempt,
  onCreate,
  isVisible,
  onClose,
  onFormValuesChange
}) => {
  const { t } = useTranslation()
  const [selectedAttachments, setSelectedAttachments] = useState<number[]>()

  return (
    <DoubleModal
      isVisible={isVisible}
      oneModalWidthMin={480}
      oneModalWidthMax={1000}
      height={1100}
      mainHeader={t('document.createDocument')}
      mainContent={
        <SuggestionForm
          isVisible={isVisible}
          suggestion={suggestion}
          attachmentExempt={attachmentExempt}
          onCreate={onCreate}
          onClose={onClose}
          onValuesUpdate={data => {
            setSelectedAttachments(data?.attachment_ids || [])
            onFormValuesChange?.(data)
          }}
        />
      }
      onClose={onClose}
      secondaryContent={
        <DocumentFormExtraDetailView
          importData={suggestion.import_data}
          attachmentIds={selectedAttachments}
        />
      }
    />
  )
}
